var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datastore-viewer',{attrs:{"document-id":_vm.documentId}})}
var staticRenderFns = []

export { render, staticRenderFns }